export const catalog_matrix = [
    {form_key:'fiscal_regime_id', catalog_key:'business_fiscal_regimes'}
];
